import { render, staticRenderFns } from "./CenteredBox.vue?vue&type=template&id=7d096156"
import script from "./CenteredBox.vue?vue&type=script&lang=js"
export * from "./CenteredBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports